import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2f493cc7&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=2f493cc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f493cc7",
  null
  
)

export default component.exports